import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";

import mainActiveReducer from "./main-active-state";
import dateFilterStateReducer from "./date-filter-state";
import respiratoryReducer from "./content-store/respiratory";
import bodyMeasurementsReducer from "./content-store/body-measurements";
import heartReducer from "./content-store/heart";
import otherDataReducer from "./content-store/other-data";
import uiStateReducer from "./ui-state";
import vitalsReducer from "./content-store/vitals";
import authProviderReducer from "./auth/auth-provider";

const combinedReducer = combineReducers({
  mainActiveState: mainActiveReducer,
  dateFilterState: dateFilterStateReducer,
  uiState: uiStateReducer,
  bodyMeasurements: bodyMeasurementsReducer,
  heart: heartReducer,
  respiratory: respiratoryReducer,
  otherData: otherDataReducer,
  vitals: vitalsReducer,
  authProvider: authProviderReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "ui state/logout") {
    state = undefined;
  }
  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
// const store = configureStore({
//   reducer: {
//     mainActiveState: mainActiveReducer,
//     dateFilterState: dateFilterStateReducer,
//     uiState: uiStateReducer,
//     bodyMeasurements: bodyMeasurementsReducer,
//     heart: heartReducer,
//     respiratory: respiratoryReducer,
//     otherData: otherDataReducer,
//     vitals: vitalsReducer,
//     authProvider: authProviderReducer,
//   },
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: false,
//     }),
// });

export default store;
